<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:00em;">This book is dedicated to my husband, Benny. Books may not be his passion, but he has always pushed me to pursue mine.</p>
<br/><p style="text-indent:00em;">And to my parents who instilled in me a love of reading.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6fdcb105